import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./Testimonials.css";

const Testimonials = ({
                          title = "Client Testimonials",
                          testimonials = [],
                          className = "",
                      }) => {
    // 🧠 Determine slidesPerView based on how many testimonials exist
    const slidesCount = testimonials.length;

    // Default: show 1 on mobile, then increase
    const slidesConfig = {
        768: { slidesPerView: Math.min(2, slidesCount) },
        1024: { slidesPerView: Math.min(3, slidesCount) },
    };

    return (
        <section className={`testimonials ${className}`}>
            <h2 className="testimonials-title">{title}</h2>

            <Swiper
                spaceBetween={30}
                loop={slidesCount > 1} // loop only if multiple slides exist
                slidesPerView={Math.min(1, slidesCount)}
                pagination={{ clickable: true }}
                navigation={slidesCount > 1}
                autoplay={slidesCount > 1 ? { delay: 3000, disableOnInteraction: false } : false}
                modules={[Pagination, Navigation, Autoplay]}
                className="mySwiper"
                breakpoints={slidesConfig}
            >
                {testimonials.map((t, i) => (
                    <SwiperSlide key={i} className="SwiperSlide">
                        <article className="testimonial-card">
                            <p className="testimonial-quote">“{t.quote}”</p>
                            <footer className="testimonial-footer">
                                <p className="testimonial-author">{t.author}</p>
                                <p className="testimonial-role">{t.role}</p>
                            </footer>
                        </article>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
};

export default Testimonials;
